import { Ellipsis, FileDown, Loader2 } from 'lucide-react';
import { useI18nContext } from '@/i18n/i18n-react';
import { mobileLayer } from '@/lib/mobile-layer';
import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { useSalesCsv } from '@/components/sales-history/use-sales-csv';
import type { SalesHistoryFilters } from '@/components/sales-history/use-sales-history-filters';

/** ⋯ menu of the mobile header in Analytics › Pedidos: "Exportar CSV" (SALES-07 AC 2). */
export function OrdersHeaderMenu({
  filters,
}: {
  filters: SalesHistoryFilters;
}) {
  const { LL } = useI18nContext();
  const csv = useSalesCsv(filters.values);

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          type="button"
          variant="ghost"
          size="icon"
          aria-label={LL.salesPage.mobile.moreActions()}
          className={mobileLayer.touch}
        >
          {csv.isLoading ? (
            <Loader2 className="size-4 animate-spin" aria-hidden />
          ) : (
            <Ellipsis className="size-5" aria-hidden />
          )}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuItem
          className="min-h-touch"
          disabled={csv.isLoading}
          onSelect={() => void csv.download()}
        >
          <FileDown className="size-4" aria-hidden />
          {LL.salesPage.mobile.exportCsv()}
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
